import type { IUpsertExpenseFormulaRequest } from '~/services/parallel/api/formulas/requestSchemas';
import { ExpenseDriverEnum, IFormattingEnum } from '~/services/parallel/formulas.types';
import type { IExpenseFormData } from './ExpenseForm';
import type { IEmploymentType } from '~/services/parallel/headcount.types';
import { CENTS_PER_DOLLAR } from '~/utils/constants/currency';

export const transformExpenseFormForSubmission = ({
  formData,
  scenarioUuid,
  formulaUuid,
}: {
  formData: IExpenseFormData;
  scenarioUuid?: string;
  formulaUuid?: string;
}): IUpsertExpenseFormulaRequest => {
  const {
    name,
    category,
    departments,
    expenseDriver,
    employmentTypes,
    amount,
    percentage,
    startDate,
    endDate,
    frequency,
    dataSourceUuids,
  } = formData;

  let finalAmount: string | undefined;
  if ([ExpenseDriverEnum.SetCost, ExpenseDriverEnum.HeadcountFixed].includes(expenseDriver as ExpenseDriverEnum)) {
    finalAmount = amount ?? undefined;
  } else if (expenseDriver === ExpenseDriverEnum.HeadcountPercentCompensation) {
    finalAmount = percentage ?? undefined;
  }

  return {
    query: { scenarioUuid, awaitCalculations: true },
    body: {
      formulaUuid,
      name,
      startDate,
      endDate: endDate ?? null,
      dataSourceUuids,
      formatting: IFormattingEnum.Currency,
      context: {
        tag: category,
        frequency,
        departments,
        employmentTypes: employmentTypes.map((employmentType) => employmentType as IEmploymentType),
        driver: expenseDriver as ExpenseDriverEnum,
        amount: finalAmount ? parseFloat(finalAmount) * CENTS_PER_DOLLAR : undefined,
      },
    },
  };
};
